import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import { useAppContext } from '../../../../../providers/AppProvider';
import { chartJsDefaultTooltip } from '../../../../../helpers/utils';

const HalfDoughnutChart = ({
  target = 50,
  reached = 50,
  color = '#f44546'
}) => {
  const { getThemeColor } = useAppContext();

  const options = {
    rotation: -90,
    circumference: '180',
    cutout: '80%',
    hover: { mode: null },
    plugins: {
      legend: {
        display: false
      },
      tooltip: chartJsDefaultTooltip(getThemeColor)
    }
  };

  const data = {
    labels: ['Tiempo en actividad', 'Tiempo sin actividad'],
    datasets: [
      {
        data: [reached, target - reached],
        backgroundColor: [getThemeColor(color), getThemeColor('gray-300')],
        borderColor: [getThemeColor(color), getThemeColor('gray-300')]
      }
    ]
  };
  return <Doughnut data={data} options={options} width="112" />;
};

HalfDoughnutChart.propTypes = {
  target: PropTypes.number,
  reached: PropTypes.number,
  color: PropTypes.string
};

export default HalfDoughnutChart;
